<div class="modal-card">
  <!-- Rubrik & Avskiljarlinje -->
  <div class="modal-header">
    <h3>{{ data.title || 'Ett fel uppstod' }}</h3>
  </div>

  <!-- Innehåll med Ikon & Meddelande -->
  <div class="modal-body">
    <div class="icon-circle" [ngClass]="iconBgClass">
      <!-- Om du använder FontAwesome: -->
      <i [class]="iconClass"></i>

    </div>
    <p class="modal-message">{{ data.message }}</p>
  </div>

  <!-- Knappar längst ner -->
  <div class="modal-actions">
    <button *ngIf="data.showRetry !== false && data.showCancel !== false"
            type="button"
            class="btn-cancel"
            (click)="onClose()">
      {{ data.secondButton || 'Stäng' }}
    </button>

    <button *ngIf="data.showRetry !== false"
            type="button"
            class="btn-primary-custom"
            (click)="onRetry()">
      <i class="fa-solid fa-rotate-right me-1"></i>
      {{ data.firstButton || 'Försök igen' }}
    </button>

    <button *ngIf="data.showRetry === false"
            type="button"
            class="btn-primary-custom"
            (click)="onClose()">
      OK
    </button>
  </div>
</div>
